import type { ReactNode } from 'react';
import LetsTalk from '@/components/promo/LetsTalk';

/**
 * 원본: views/home/termcondition.pug
 * 법률 문서 페이지 공통 레이아웃 (T&C, Privacy 등)
 */
export default function TermsLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div id="terms-and-conditions">
      <div className="terms-hero">
        <h1>{title}</h1>
      </div>
      <div className="terms-content">
        <div className="terms-inner">
          {children}
        </div>
      </div>
      <LetsTalk />
    </div>
  );
}
